import { render, staticRenderFns } from "./MpLevelPrev.vue?vue&type=template&id=61b13f9c&"
import script from "./MpLevelPrev.vue?vue&type=script&lang=js&"
export * from "./MpLevelPrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports